import type { JSX, ReactNode } from 'react';
import { PageLayout, SideBar, SplitView, TopBar } from '@ksyos/design-system';
import { useState } from 'react';
import { useSplitViewContext } from '@frontend/utils/hooks/useSplitViewContext';
import { useUiStateContext } from '@frontend/utils/hooks/useUiState';

export interface IPageTemplateProps {
    children: ReactNode;
    noGutterOnMobile?: boolean;
    sideBarNavigation?: JSX.Element;
    sideBarProfile?: JSX.Element;
    topBarNavigation?: JSX.Element;
    topBarProfile?: JSX.Element;
    width?: 'small' | 'medium' | 'large' | 'full';
}

export function PageTemplate(props: IPageTemplateProps) {
    const { uiState, dispatchUiStateAction } = useUiStateContext();
    const { isSplitViewOpen, splitViewContent } = useSplitViewContext();
    const [splitViewWidth, setSplitViewWidth] = useState(420);

    return (
        <PageLayout
            isSplitViewOpen={isSplitViewOpen}
            noGutterOnMobile={props.noGutterOnMobile}
            onSplitViewWidthChange={setSplitViewWidth}
            sideBar={
                (props.sideBarProfile || props.sideBarNavigation) && (
                    <SideBar
                        bannerHeight={uiState.bannerHeight}
                        content={props.sideBarNavigation}
                        header={props.sideBarProfile}
                    />
                )
            }
            splitView={<SplitView>{splitViewContent}</SplitView>}
            splitViewWidth={splitViewWidth}
            topBar={
                (props.topBarProfile || props.topBarNavigation) && (
                    <TopBar
                        content={props.topBarNavigation}
                        header={props.topBarProfile}
                        isOpen={uiState.isTopBarOpen}
                        onClose={() => dispatchUiStateAction({ isTopBarOpen: false, type: 'setIsTopBarOpen' })}
                        onToggle={() =>
                            dispatchUiStateAction({ isTopBarOpen: !uiState.isTopBarOpen, type: 'setIsTopBarOpen' })
                        }
                    />
                )
            }
            width={props.width}
        >
            {props.children}
        </PageLayout>
    );
}
